import { fetcher } from '@commenda/utils';

import type {
  FilingsAuditorFindingReviewDecision,
  IFilingsAuditorFindingView,
  IFilingsAuditorMutationResult,
} from './types';

export async function reviewFilingsAuditorFinding(
  findingId: string,
  decision: FilingsAuditorFindingReviewDecision,
  note?: string
): Promise<IFilingsAuditorMutationResult<IFilingsAuditorFindingView>> {
  try {
    const response = await fetcher(
      `agent-platform/filings-auditor/findings/${findingId}/reviews`,
      {
        method: 'POST',
        body: { decision, note },
      }
    );
    if (!response.ok) {
      const error = (await response.json().catch(() => null)) as {
        message?: string;
      } | null;
      return {
        success: false,
        error: error?.message ?? 'Failed to save review.',
      };
    }
    const data: { finding: IFilingsAuditorFindingView } = await response.json();
    return { success: true, data: data.finding };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to save review.',
    };
  }
}
